module.exports = __webpack_public_path__ + "static/media/0030_IMG_LES_ENSEIGNES_LE_PRIMEUR_SCRABBLE.34440f77.png";